<cs-segment [(selection)]="bfData.method" (selectionChange)="onMethodChange()">
  <cs-segment-button [value]="BFMethod.Self">{{ LL.bodyfatInput.methods.visual() }}</cs-segment-button>
  <cs-segment-button [value]="BFMethod.Caliper">{{ LL.bodyfatInput.methods.caliper() }}</cs-segment-button>
  @if (shouldOfferTapeMeasureMethod) {
    <cs-segment-button [value]="BFMethod.Tape">{{ LL.bodyfatInput.methods.tape() }}</cs-segment-button>
  }
</cs-segment>
@if (bfData.method === BFMethod.Caliper) {
  <!-- Help text with link -->
  <cs-note light>
    {{ LL.bodyfatInput.labels.take5Measurements() }}
    <help-link variant="gray" helpId="@help:intake.bodyfat-caliper">{{ LL.bodyfatInput.links.howToMeasure() }}</help-link>
  </cs-note>
  <!-- Skinfold sections -->
  <div class="skinfold-grid">
    @for (fold of skinfolds; track fold) {
      @if ((gender === Gender.male && fold.male) || (gender === Gender.female && fold.female)) {
        <cs-skinfold-site-measure
          [siteName]="fold.name" [sitePhoto]="(gender === Gender.male) ? fold.photoM : fold.photoF"
          [(measures)]="bfData[fold.id]" (onValueChange)="bodyfatPercentChanged()">
        </cs-skinfold-site-measure>
      }
    }
  </div>
}

@if (bfData.method === BFMethod.Self) {
  <!-- Input field with label -->
  <cs-form-field fit-width [label]="LL.bodyfatInput.labels.bodyFatPercentage()">
    <cs-input-measure type="bodyfat_pc" [(canonValue)]="bfData.bfSelf_pc" (canonValueChange)="bodyfatPercentChanged()">
    </cs-input-measure>
  </cs-form-field>
  <!-- Help text -->
  <cs-note light>{{ LL.bodyfatInput.descriptions.visual() }}</cs-note>
  <!-- Image carousel -->
  <div #bfImagesHolder class="images-holder">
    <div class="images-slider" (scroll)="onBfImageHolderScroll($event)">
      @for (img of bfImageForPercentCurrent; track img; let i = $index) {
        <div class="image" tappable
          (click)="handleImageZoomButtonClick($event, img.image)">
          <img [src]="img.image" />
          <div class="bf-percentage-badge">
            {{ img.value }}%
          </div>
        </div>
      }
    </div>
  </div>
  <div class="image-arrow-holder">
    <cs-icon name="arrow-point-up"></cs-icon>
  </div>
  <!-- Slider -->
  <cs-slider [(value)]="bfData.bfSelf_pc" [min]="bfImageForPercentCurrent[0].value"
    [max]="bfImageForPercentCurrent[bfImageForPercentCurrent.length-1].value" [step]="0.1"
    [tickmarks]="gender === Gender.male ? bfSliderTickmarksMale : bfSliderTickmarksFemale"
    (valueChange)="onBfSliderValueChanged($event)" [step]="0.1">
  </cs-slider>
}

@if (bfData.method === BFMethod.Tape) {
  <!-- Warning alert -->
  <cs-text-alert type="warning">
    {{ LL.bodyfatInput.warnings.roughEstimate() }}
  </cs-text-alert>
  <!-- Input fields with labels above and help text below -->
  <cs-form-field [label]="LL.bodyfatInput.labels.neckCircumference()">
    <cs-item vertical>
      <cs-input-measure type="bodydimensions_cm" [(canonValue)]="bfData.neck_cm"
        (canonValueChange)="bodyfatPercentChanged()">
      </cs-input-measure>
    </cs-item>
    <cs-note>{{ LL.bodyfatInput.helpText.neckCircumference() }}</cs-note>
  </cs-form-field>
  <!-- Abdomen/Waist circumference (gender-specific) -->
  @if (gender === Gender.male) {
    <cs-form-field [label]="LL.bodyfatInput.labels.abdomenCircumference()">
      <cs-item vertical>
        <cs-input-measure type="bodydimensions_cm" [(canonValue)]="bfData.abdomen_cm"
          (canonValueChange)="bodyfatPercentChanged()">
        </cs-input-measure>
      </cs-item>
      <cs-note>{{ LL.bodyfatInput.helpText.abdomenCircumference() }}</cs-note>
    </cs-form-field>
  }
  @if (gender === Gender.female) {
    <cs-form-field [label]="LL.bodyfatInput.labels.waistCircumference()">
      <cs-item vertical>
        <cs-input-measure type="bodydimensions_cm" [(canonValue)]="bfData.waist_cm"
          (canonValueChange)="bodyfatPercentChanged()">
        </cs-input-measure>
      </cs-item>
      <cs-note>{{ LL.bodyfatInput.helpText.waistCircumference() }}</cs-note>
    </cs-form-field>
  }
  <!-- Hips circumference (female only) -->
  @if (gender === Gender.female) {
    <cs-form-field [label]="LL.bodyfatInput.labels.hipsCircumference()">
      <cs-item vertical>
        <cs-input-measure type="bodydimensions_cm" [(canonValue)]="bfData.hip_cm"
          (canonValueChange)="bodyfatPercentChanged()">
        </cs-input-measure>
      </cs-item>
      <cs-note>{{ LL.bodyfatInput.helpText.hipsCircumference() }}</cs-note>
    </cs-form-field>
  }
}